export default __webpack_public_path__ + "static/media/request.30282952.png";